<mat-card appearance="outlined">
	<mat-card-title class="row d-flex justify-content-between">
		<p class="col">Dane zgłaszającego</p>
		<button mat-icon-button [matMenuTriggerFor]="menu" class="fs-5 ownerMenuButton">
			<i class="col text-end cursor-pointer fa fa-ellipsis-vertical"></i>
		</button>
		<mat-menu #menu>
			<button
				mat-menu-item
				(click)="showOwnerReservations()"
				*ngIf="reservation.ownerUser"
				class="showOwnerReservationsBtn"
			>
				<span>Pokaż rezerwacje zgłaszającego</span>
			</button>
			<button mat-menu-item (click)="changeOwner(ownerUser || ownerOrganization)">
				<span> Zmień dane zgłaszającego</span>
			</button>
			<button mat-menu-item (click)="changeOwner(null, true)">
				<span>Zmień zgłaszającego</span>
			</button>
		</mat-menu>
	</mat-card-title>
	<mat-card-content>
		<mat-table [dataSource]="matPersonalInformationData" matSort matSortActive="id" matSortDirection="asc">
			<ng-container [matColumnDef]="isOrganization ? 'name' : 'sex'">
				<mat-header-cell *matHeaderCellDef>
					{{ isOrganization ? 'Nazwa' : 'Płeć' }}
				</mat-header-cell>
				<mat-cell *matCellDef="let element">{{ isOrganization ? element?.name : element?.sex }}</mat-cell>
			</ng-container>

			<ng-container [matColumnDef]="isOrganization ? 'nip' : 'firstName'">
				<mat-header-cell *matHeaderCellDef>{{ isOrganization ? 'NIP' : 'Imię' }}</mat-header-cell>
				<mat-cell *matCellDef="let element">
					{{ isOrganization ? element?.nip : element?.firstName }}
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="lastName" *ngIf="!isOrganization">
				<mat-header-cell *matHeaderCellDef> Nazwisko</mat-header-cell>
				<mat-cell *matCellDef="let element">
					{{ element.lastName }}
				</mat-cell>
			</ng-container>
			<ng-container matColumnDef="phone_number">
				<mat-header-cell *matHeaderCellDef> Numer telefonu </mat-header-cell>
				<mat-cell *matCellDef="let element">
					{{ element?.phone_number }}
				</mat-cell>
			</ng-container>
			<ng-container matColumnDef="email">
				<mat-header-cell *matHeaderCellDef> Adres e-mail </mat-header-cell>
				<mat-cell *matCellDef="let element">
					{{ element?.email }}
				</mat-cell>
			</ng-container>

			<mat-header-row *matHeaderRowDef="displayedPersonalInfoColumns"></mat-header-row>
			<mat-row *matRowDef="let row; columns: displayedPersonalInfoColumns"></mat-row>
		</mat-table>
	</mat-card-content>
</mat-card>
